<template>
  <div>
    <organization-details-menu></organization-details-menu>

    <data-table :service="JobService"
                operations="add, refresh"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                ref="table">
      <div class="d-flex" slot="title" slot-scope="{row}">
        <base-avatar :name="row.title" :src="row.logo"></base-avatar>
        <div class="ml-2 d-flex flex-column justify-content-center">
          <router-link :to="`/jobs/${row.uuid}`" class="text-capitalize font-weight-bold">
            {{row.title}}
          </router-link>
        </div>
      </div>

      <div class="d-flex flex-column" slot="job_board" slot-scope="{row}">
        <router-link v-for="board in row.job_boards" :key="board.id" :to="`/content/job-board/${board.id}`">
          {{board.name}}
        </router-link>
      </div>

      <template slot="till" slot-scope="{row}">
        {{$formatDate(row.till, FRIENDLY_DATE_FORMAT)}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import JobService from 'src/services/JobService'
  import entities from 'src/config/entities'
  import OrganizationDetailsMenu from './OrganizationDetailsMenu'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'organization-jobs',
    components: {
      OrganizationDetailsMenu
    },
    data () {
      return {
        FRIENDLY_DATE_FORMAT,
        JobService,
        entity: entities.JOB
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'title',
            label: this.$t('job.list.columns.title'),
            minWidth: '180px',
            sortable: true
          },
          {
            prop: 'job_board',
            label: this.$t('job.list.columns.job_board'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'till',
            label: this.$t('job.list.columns.till'),
            minWidth: '130px',
            sortable: true
          }
        ]
      },
      filters () {
        return [
          {
            key: 'match[organisation_id]',
            value: this.$route.params.id
          },
          {
            key: 'with',
            value: 'job_boards'
          }
        ]
      }
    }
  }
</script>
<style>
</style>
